import { Theme } from '@mui/material';

export const drawerStyles = (theme: Theme) => ({
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: theme.palette.background.default,
      },
    },
  },
});
